export function validateTrafficLightAssignments(assignments, relayCount, gates = []) {
    const errors = {};
    const used = new Set(gates.flatMap((gate) => (gate.relays || []).map((relay) => Number(relay.index))));
    assignments.forEach((assignment, row) => {
        const prefix = `gpio_traffic_light_assignments.${row}.relays`;
        const relays = assignment.relays || [];
        if (relays.length !== 3) errors[prefix] = ['Select exactly three output relays: red, amber and green.'];
        if (relays.some((relay) => !['red', 'amber', 'green'].includes(relay.action)) || new Set(relays.map((relay) => relay.action)).size !== relays.length) {
            errors[prefix] = ['Assign one relay for each color: red, amber and green.'];
        }
        relays.forEach((relay, index) => {
            const pin = Number(relay.index);
            if (!Number.isInteger(pin) || pin < 1 || pin > relayCount) {
                errors[`${prefix}.${index}.index`] = ['Choose a relay within this device’s relay count.'];
            } else if (used.has(pin)) {
                errors[`${prefix}.${index}.index`] = ['A relay cannot be shared between gates or traffic lights.'];
            }
            used.add(pin);
            const seconds = Number(relay.timeout);
            if (!Number.isFinite(seconds) || seconds < 0.01 || seconds > 86400) {
                errors[`${prefix}.${index}.timeout`] = ['Enter a duration between 0.01 and 86400 seconds.'];
            }
        });
    });
    return errors;
}
